<template>
  <el-container style="height: 100vh; display: flex; flex-direction: column; justify-content: center; align-items: center;">
    <!-- Header -->
    <el-header>
      <h2>题目答题页面</h2>
    </el-header>

    <!-- Main Content -->
    <el-main>
      <el-card style="width: 400px; padding: 20px;">
        <div class="clearfix">
          <span>题目：{{ currentQuestion.question }}</span>
        </div>

        <div>
          <!-- 根据题目类型渲染不同输入组件 -->
          <div v-if="currentQuestion.type === '填空题'">
            <el-input v-model="userAnswer" placeholder="请输入答案" clearable></el-input>
          </div>

          <div v-if="currentQuestion.type === '选择题'">
            <el-radio-group v-model="userAnswer">
              <el-radio :label="option" v-for="option in currentQuestion.options" :key="option">{{ option }}</el-radio>
            </el-radio-group>
          </div>

          <!-- 提交按钮 -->
          <el-button type="primary" @click="checkAnswer" style="margin-top: 20px;">提交答案</el-button>

          <!-- 显示结果 -->
          <p v-if="resultMessage !== null" :style="resultStyle">{{ resultMessage }}</p>

          <!-- 上一题按钮 -->
          <el-button @click="previousQuestion" style="margin-top: 20px;" :disabled="currentQuestionIndex === 0">上一题</el-button>

          <!-- 下一题按钮 -->
          <el-button @click="nextQuestion" style="margin-top: 20px;" :disabled=" currentQuestionIndex === questions.length - 1">下一题</el-button>
        </div>
      </el-card>
    </el-main>
  </el-container>
</template>

<script>
import { ElContainer, ElHeader, ElMain, ElCard, ElButton, ElInput, ElRadioGroup, ElRadio } from 'element-plus';

export default {
  name: 'QuestionPage',
  components: {
    ElContainer,
    ElHeader,
    ElMain,
    ElCard,
    ElButton,
    ElInput,
    ElRadioGroup,
    ElRadio
  },
  data() {
    return {
      questions: [
        {
          question: "计算 5 + 3 等于多少？",
          type: "填空题",
          correctAnswer: "8"
        },
        {
          question: "哪个是地球的卫星？",
          type: "选择题",
          options: ["太阳", "月球", "火星", "金星"],
          correctAnswer: "月球"
        }
        // 可以继续添加更多题目
      ],
      currentQuestionIndex: 0, // 当前题目索引
      currentQuestion: null, // 当前题目
      userAnswer: "", // 用户输入的答案
      resultMessage: null, // 提交后的结果信息
      resultStyle: {} // 结果的样式
    };
  },
  watch: {
    // 当当前题目发生变化时，更新 currentQuestion
    currentQuestionIndex(newIndex) {
      this.currentQuestion = this.questions[newIndex];
      this.userAnswer = ''; // 清空用户答案
      this.resultMessage = null; // 清空结果信息
      this.resultStyle = {}; // 清空样式
    }
  },
  methods: {
    // 检查答案
    checkAnswer() {
      if (this.userAnswer === this.currentQuestion.correctAnswer) {
        this.resultMessage = "回答正确！";
        this.resultStyle = { color: 'green' };
      } else {
        this.resultMessage = "回答错误，请再试一次。";
        this.resultStyle = { color: 'red' };
      }
    },
    // 下一题
    nextQuestion() {
      if (this.currentQuestionIndex < this.questions.length - 1) {
        this.currentQuestionIndex++;
      } else {
        this.resultMessage = "你已答完所有题目！";
        this.resultStyle = { color: 'blue' };
      }
    },
    // 上一题
    previousQuestion() {
      if (this.currentQuestionIndex > 0) {
        this.currentQuestionIndex--;
      }
    }
  },
  created() {
    // 初始化时加载第一道题目
    this.currentQuestion = this.questions[this.currentQuestionIndex];
  }
};
</script>

<style scoped>
h2 {
  //color: #409eff;
  text-align: center;
  margin-bottom: 20px;
}

.el-card {
  text-align: center;
}
</style>
